import businessServices from "../services/businessInfo.service";
import {
  GET_BUSINESS_LIST,
  SET_BUSINESS_ACTIVATION_PLAN,
  SET_ALL_COMPANY_APPOINTED_LIST,
  SET_FAILED_MESSAGE,
  SET_SUCCESS_MESSAGE,
  START_LOADER,
  STOP_LOADER,
} from "./types";
export const getBusinessAction =
  (
    page,
    perPage,
    search,
    planFilter = '',
    callToAction = '',
    isRegister = '',
    startDate = '',
    endDate = '',
    tangibleAsset = '',
    financialObjective = '',
    verificationMethod = '',
    isDefault = false
  ) =>
    (dispatch) => {
      dispatch({ type: START_LOADER });
      return businessServices
        .getBusinessInfo(
          page,
          perPage,
          search,
          planFilter,
          callToAction,
          isRegister,
          startDate,
          endDate,
          tangibleAsset,
          financialObjective,
          verificationMethod,
          isDefault
        )
        .then((resp) => {
          if (resp.status) {
            dispatch({
              type: GET_BUSINESS_LIST,
              payload: resp.data,
              count: resp.count,
            });
          } else {
            dispatch({ type: GET_BUSINESS_LIST, payload: [] });
          }
          dispatch({ type: STOP_LOADER });
        });
    };

export const resetBusinessList = () => (dispatch) => {
  dispatch({ type: GET_BUSINESS_LIST, payload: [] });
}

export const editCompanyAction = (companyId, id, value, filterBody = null) => async (dispatch) => {
  dispatch({ type: START_LOADER });
  return businessServices
    .editCompanyNotification(companyId, id, value)
    .then((resp) => {
      if (resp.status) {
        dispatch({
          type: SET_SUCCESS_MESSAGE,
          payload: resp.data,
        });
        dispatch(filterGetBusinessAction(filterBody));
      } else {
        dispatch({ type: SET_FAILED_MESSAGE, payload: resp.data });
      }
      dispatch({ type: STOP_LOADER });
    });
};

export const editCompanyPosition = (id, payloadId, filterBody = null) => async (dispatch) => {
  dispatch({ type: START_LOADER });
  return businessServices.editCompanyPosition(id, payloadId).then((resp) => {
    if (resp.status) {
      dispatch({
        type: SET_SUCCESS_MESSAGE,
        payload: resp.data,
      });
      dispatch(filterGetBusinessAction(filterBody));
    } else {
      dispatch({ type: SET_FAILED_MESSAGE, payload: resp.data });
    }
    dispatch({ type: STOP_LOADER });
  });
};

export const updateBusinessInfo = (payload, filterBody) => async (dispatch) => {
  dispatch({ type: START_LOADER });
  return businessServices.updatebusinessInfo(payload).then((resp) => {
    if (resp.status) {
      dispatch({ type: SET_SUCCESS_MESSAGE, payload: resp.data });
      dispatch(getBusinessAction(1, 20)
      );
    } else {
      dispatch({ type: SET_FAILED_MESSAGE, payload: resp.data });
    }
    dispatch({ type: STOP_LOADER });
  });
};


export const getAllAppointedListAction = () => async (dispatch) => {
  return businessServices.getAllCompanyAppointedList().then(async (resp) => {
    dispatch({ type: SET_ALL_COMPANY_APPOINTED_LIST, payload: resp.data });
  })
}


export const updateBobCtaAction = (companyId, payload, filterBody = null) => (dispatch) => {
  dispatch({ type: START_LOADER });
  return businessServices.updateBobCta(companyId, payload).then((resp) => {
    if (resp.status) {
      dispatch({
        type: SET_SUCCESS_MESSAGE,
        payload: resp.data,
      });
      dispatch(filterGetBusinessAction(filterBody));
    } else {
      dispatch({ type: SET_FAILED_MESSAGE, payload: resp.data });
    }
    dispatch({ type: STOP_LOADER });
  });
};


export const filterGetBusinessAction = (filterBody) => (dispatch) => {
  if (filterBody) {
    dispatch(getBusinessAction(filterBody.page, filterBody.limit, filterBody.search, filterBody.planFilter, filterBody.callToAction, filterBody.isRegister, filterBody.startDate, filterBody.endDate, filterBody.tangibleAsset, filterBody.financialObjective, filterBody.verificationMethod, filterBody?.isDefault));
  }
}

export const approveCompanyAction = (companyId, flag = true, filterBody = null) => (dispatch) => {
  dispatch({ type: START_LOADER });
  return businessServices.approveCompany(companyId, flag).then((resp) => {
    if (resp.status) {
      dispatch({
        type: SET_SUCCESS_MESSAGE,
        payload: resp.data,
      });
      dispatch(filterGetBusinessAction(filterBody));
    } else {
      dispatch({ type: SET_FAILED_MESSAGE, payload: resp.data });
    }
    dispatch({ type: STOP_LOADER });
  });
};

export const enableDisableAdvisorAction = (companyId, flag = true, filterBody = null) => (dispatch) => {
  dispatch({ type: START_LOADER });
  return businessServices.enableDisableAdvisor(companyId, flag).then((resp) => {
    if (resp.status) {
      dispatch({
        type: SET_SUCCESS_MESSAGE,
        payload: resp.data,
      });
      dispatch(filterGetBusinessAction(filterBody));
    } else {
      dispatch({ type: SET_FAILED_MESSAGE, payload: resp.data });
    }
    dispatch({ type: STOP_LOADER });
  });
};

export const makeKimbocorpAdvisorAction = (companyId, filterBody = null) => (dispatch) => {
  dispatch({ type: START_LOADER });
  return businessServices.makeKimbocorpAdvisor(companyId).then((resp) => {
    if (resp.status) {
      dispatch({
        type: SET_SUCCESS_MESSAGE,
        payload: resp.data,
      });
      dispatch(filterGetBusinessAction(filterBody));
    } else {
      dispatch({ type: SET_FAILED_MESSAGE, payload: resp.data });
    }
    dispatch({ type: STOP_LOADER });
  });
}; 

const getBusinessActivationError = (error) => {
  const message = error?.response?.data?.data || error?.response?.data?.message || error?.response?.data || "Something wen't wrong";
  return typeof message === "string" ? message : JSON.stringify(message);
};

const getBusinessActivationResponseError = (data) => {
  return typeof data === "string" ? data : JSON.stringify(data);
};

const getBusinessActivationCompany = (resp) => {
  return resp.company || resp.data?.company || resp.data;
};

const handleBusinessActivationSuccess = (dispatch, resp, filterBody) => {
  dispatch({
    type: SET_BUSINESS_ACTIVATION_PLAN,
    payload: getBusinessActivationCompany(resp),
  });
  dispatch({
    type: SET_SUCCESS_MESSAGE,
    payload: "Business activated successfully.",
  });
  dispatch(filterGetBusinessAction(filterBody));
};

export const activateBusinessPaymentAction = (payload, filterBody = null) => (dispatch) => {
  dispatch({ type: START_LOADER });
  return businessServices.activateBusinessPayment(payload)
    .then((resp) => {
      if (resp.status) {
        handleBusinessActivationSuccess(dispatch, resp, filterBody);
      } else {
        dispatch({ type: SET_FAILED_MESSAGE, payload: getBusinessActivationResponseError(resp.data) });
      }
      dispatch({ type: STOP_LOADER });
      return resp;
    })
    .catch((error) => {
      const message = getBusinessActivationError(error);
      dispatch({ type: SET_FAILED_MESSAGE, payload: message });
      dispatch({ type: STOP_LOADER });
      return { status: false, data: message };
    });
};

export const activateBusinessManualAction = (payload, filterBody = null) => (dispatch) => {
  dispatch({ type: START_LOADER });
  return businessServices.activateBusinessManual(payload)
    .then((resp) => {
      if (resp.status) {
        handleBusinessActivationSuccess(dispatch, resp, filterBody);
      } else {
        dispatch({ type: SET_FAILED_MESSAGE, payload: getBusinessActivationResponseError(resp.data) });
      }
      dispatch({ type: STOP_LOADER });
      return resp;
    })
    .catch((error) => {
      const message = getBusinessActivationError(error);
      dispatch({ type: SET_FAILED_MESSAGE, payload: message });
      dispatch({ type: STOP_LOADER });
      return { status: false, data: message };
    });
};
